import { Time } from '@angular/common';
import { Dayjs } from 'dayjs';
import { CommonUtils } from '@infodata-group/inf-commons';
import { ProductionColumn } from '../model/production-column';
import { ProductionColumnGroup } from '../model/production-column-group';

export class DateUtils {
  public static LABEL_SIZE = 161;
  public static convertNumberToTime(x: number): Time {
    const abs = Math.abs(x);
    let hours = Math.floor(abs);
    const minutes = Math.round((abs - hours) * 60);
    hours = x < 0 ? hours * -1 : hours;
    return { hours, minutes };
  }

  public static convertTimeToMinutes(time: string): number {
    if (time) {
      const split = time.split(':');
      if (split.length === 2) {
        return parseInt(split[0], 10) * 60 + parseInt(split[1], 10);
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  public static formatDate(d: Dayjs | Date | string): string {
    if (typeof d === 'string') {
      return d;
    } else {
      if (d instanceof Date) {
        return CommonUtils.convertDateToString(d);
      } else {
        return CommonUtils.convertDateToString(d.toDate());
      }
    }
  }

  static generateMonth(dateRef: Dayjs) {
    let x = dateRef.startOf('month');
    const days: ProductionColumn[] = [];
    while (x.month() <= dateRef.month()) {
      days.push(
        new ProductionColumn(
          x.date(),
          x.date(),
          CommonUtils.isToday(x.toDate()),
        ),
      );
      x = x.add(1, 'd');
    }
    return days;
  }

  static generate3Months(dateRef: Dayjs): ProductionColumnGroup[] {
    let x = dateRef.subtract(1, 'month').startOf('month');
    const end = dateRef.add(2, 'month').startOf('month');
    const groups: ProductionColumnGroup[] = [];
    let currentGroup = new ProductionColumnGroup(
      x.month() + '',
      x.format('MMMM YYYY'),
    );
    groups.push(currentGroup);
    while (x.isBefore(end, 'date')) {
      if (x.month() + '' !== currentGroup.id) {
        currentGroup = new ProductionColumnGroup(
          x.month() + '',
          x.format('MMMM YYYY'),
        );
        groups.push(currentGroup);
      }
      currentGroup.add(
        new ProductionColumn(
          x.date(),
          x.date(),
          CommonUtils.isToday(x.toDate()),
          x.day() === 0 || x.day() === 6,
        ),
      );
      x = x.add(1, 'd');
    }
    return groups;
  }

  static dayCount(start: Dayjs, end: Dayjs) {
    return end.diff(start, 'd') + 1;
  }
}
